import { useResponsive } from "../../hooks/useResponsive";

const ResponsiveComponent = ({
  mobileComponent: MobileComponent,
  desktopComponent: DesktopComponent,
  ...props
}) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();

  if (isMobile && MobileComponent) {
    return <MobileComponent {...props} />;
  }

  if ((isDesktop || isTablet) && DesktopComponent) {
    return <DesktopComponent {...props} />;
  }

  return null;
};

export default ResponsiveComponent;
